// extracted by extract-css-chunks-webpack-plugin
module.exports = {"col_box":"col_box-3f5iAFvG","col_navlist":"col_navlist-2VU2xjOy","pa":"pa-2oyeKXwl"};